/*!
FullCalendar Core v6.1.15
Docs & License: https://fullcalendar.io
(c) 2024 Adam Shaw
*/ !function(e) {
    "use strict";
    function t(e) {
        return "Tag" === e || "Monat" === e ? "r" : "Jahr" === e ? "s" : "";
    }
    var n = {
        code: "de",
        week: {
            dow: 1,
            doy: 4
        },
        buttonText: {
            prev: "Zur\xfcck",
            next: "Vor",
            today: "Heute",
            year: "Jahr",
            month: "Monat",
            week: "Woche",
            day: "Tag",
            list: "Termin\xfcbersicht"
        },
        weekText: "KW",
        weekTextLong: "Woche",
        allDayText: "Ganzt\xe4gig",
        moreLinkText: (e)=>"+ weitere " + e,
        noEventsText: "Keine Ereignisse anzuzeigen",
        buttonHints: {
            prev: (e)=>`Vorherige${t(e)} ${e}`,
            next: (e)=>`N\xe4chste${t(e)} ${e}`,
            today: (e)=>"Tag" === e ? "Heute" : `Diese${t(e)} ${e}`
        },
        viewHint: (e)=>e + ("Woche" === e ? "n" : "Monat" === e ? "s" : "es") + "ansicht",
        navLinkHint: "Gehe zu $0",
        moreLinkHint: (e)=>"Zeige " + (1 === e ? "ein weiteres Ereignis" : e + " weitere Ereignisse"),
        closeHint: "Schlie\xdfen",
        timeHint: "Uhrzeit",
        eventHint: "Ereignis"
    };
    FullCalendar.globalLocales.push(n);
}();

//# sourceMappingURL=index.b3b7468f.js.map
